import { render, staticRenderFns } from "./PageJiFen.vue?vue&type=template&id=4f652a25&scoped=true&"
import script from "./PageJiFen.vue?vue&type=script&lang=js&"
export * from "./PageJiFen.vue?vue&type=script&lang=js&"
import style0 from "./PageJiFen.vue?vue&type=style&index=0&id=4f652a25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f652a25",
  null
  
)

export default component.exports